import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=1554f1c2&scoped=true&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=1554f1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554f1c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
